export default "//static.glanacion.com/v2/myaccount/images/black_familiar.png";